import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import OrganizationMain from "@/components/OrganizationMain";
import OrganizationSite from "@/components/OrganizationSite";
import OrganizationSiteSettings from "@/components/OrganizationSiteSettings";
import OrganizationSiteTesting from "@/components/OrganizationSiteTesting";
import OrganizationSiteTestingStrategy from "@/components/OrganizationSiteTestingStrategy";
import Admin from "@/components/Admin";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "HelloWorld",
      component: HelloWorld,
    },
    {
      path: "/organizations/me/",
      name: "OrganizationMain",
      component: OrganizationMain,
    },
    {
      path: "/organizations/me/strategies/",
      name: "OrganizationSiteTesting",
      component: OrganizationSiteTesting,
    },
    {
      path: "/organizations/me/strategies/:strategy_public_key/",
      name: "OrganizationSiteTestingStrategy",
      component: OrganizationSiteTestingStrategy,
    },
    {
      path: "/organizations/me/sites/:public_key/",
      name: "OrganizationSite",
      component: OrganizationSite,
    },
    {
      path: "/organizations/me/sites/:public_key/settings/",
      name: "OrganizationSiteSettings",
      component: OrganizationSiteSettings,
    },
    {
      path: "/admin/",
      name: "Admin",
      component: Admin
    },
    {
      path: "/docs/",
      name: "Docs",
      component: HelloWorld,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js